import React, { useState } from 'react'
import { CallDark, EmailDark } from '../../../assests/ExportImageIcon'
import './helpSupport.css'

const SUPPORT_TABS = [
    // { key: 'ai-chat', label: 'AI Chat' },
    // { key: 'ai-call', label: 'AI Call' },
    { key: 'faqs', label: "FAQ's" },
    { key: 'contact', label: 'Contact' },
]

const CONTACT_CARDS = [
    { icon: CallDark, label: 'Phone Number', value: '+1 (234) 567 8900' },
    { icon: EmailDark, label: 'Email Support', value: 'support@sabraah.com' },
]

const BUSINESS_HOURS = [
    'Monday - Friday: 9 AM - 6 PM EST',
    'Saturday - Sunday: 10 AM - 4 PM EST',
]

const FAQS = [
    { q: 'How do I cancel my booking?', a: 'Go to My Trips, select the booking, and click on Cancel Booking. Refunds are processed based on the cancellation policy.' },
    { q: 'When will I get my refund?', a: 'Refunds are processed within 7-14 business days to your original payment method.' },
    { q: 'Can I modify my booking?', a: 'Yes, you can modify your booking from My Trips, subject to the service provider’s modification policy.' },
    { q: 'What payment methods are accepted?', a: 'We accept credit/debit cards, UPI, net banking, and digital wallets.' },
    { q: 'What payment methods are accepted?', a: 'We accept credit/debit cards, UPI, net banking, and digital wallets.' },
    { q: 'What payment methods are accepted?', a: 'We accept credit/debit cards, UPI, net banking, and digital wallets.' },
    { q: 'What payment methods are accepted?', a: 'We accept credit/debit cards, UPI, net banking, and digital wallets.', bold: true },
    { q: 'What payment methods are accepted?', a: 'We accept credit/debit cards, UPI, net banking, and digital wallets.' },
]

const AccordionChevron = ({ open }) => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" style={{ transform: open ? 'rotate(180deg)' : 'none', transition: '.2s ease' }}>
        <path d="M4 6l4 4 4-4" stroke="#026D4D" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

const HelpSupport = () => {
    const [activeTab, setActiveTab] = useState('faqs')
    const [openIndex, setOpenIndex] = useState(0)

    return (
        <div className='helpSupport'>
            <div className='helpSupportTabs'>
                {SUPPORT_TABS.map((tab) => (
                    <div
                        className={`helpSupportTabs__item ${activeTab === tab.key ? 'helpSupportTabs__item--active' : ''}`}
                        key={tab.key}
                        onClick={() => setActiveTab(tab.key)}
                    >
                        {tab.label}
                    </div>
                ))}
            </div>

            {activeTab === 'faqs' && (
                <>
                    <div className='bsSectionTitle mt-4'>Frequently Asked Questions</div>
                    <div className='helpFaqList'>
                        {FAQS.map((faq, index) => (
                            <div
                                className='bgWhite commonBorder borderRadius20 paddingCommon20 helpFaqItem'
                                key={index}
                                onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                            >
                                <div className='helpFaqItem__head'>
                                    <span className={`helpFaqItem__q ${faq.bold ? 'helpFaqItem__q--bold' : ''}`}>{faq.q}</span>
                                    <AccordionChevron open={openIndex === index} />
                                </div>
                                {openIndex === index && <p className='helpFaqItem__a'>{faq.a}</p>}
                            </div>
                        ))}
                    </div>
                </>
            )}

            {activeTab === 'contact' && (
                <>
                    <div className='bsSectionTitle mt-4'>Contact</div>
                    <div className='kycDocGrid'>
                        {CONTACT_CARDS.map((card, index) => (
                            <div className='bgWhite commonBorder borderRadius20 paddingCommon20 langCurrentBox' key={index}>
                                <span className='securityMenuItem__icon helpContactIcon'>
                                    <img src={card.icon} alt="" />
                                </span>
                                <div>
                                    <div className='langCurrentBox__label'>{card.label}</div>
                                    <div className='langCurrentBox__value'>{card.value}</div>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className='bsSectionTitle mt-4'>Business Hours</div>
                    <div className='bsBox'>
                        <div className='termsContactBlock termsContactBlock--plain'>
                            {BUSINESS_HOURS.map((line, index) => (
                                <div className='termsContactRow' key={index}>{line}</div>
                            ))}
                        </div>
                    </div>
                </>
            )}
        </div>
    )
}

export default HelpSupport
